import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiServerService } from 'app/shared/services/api-server.service';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { AccountActions } from '../actions/account.actions';
import { Account } from '@smmof/entity';
import { Store } from '@ngrx/store';
import { AccountState } from '../reducers/account.reducer';

@Injectable()
export class AccountEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiServerService,
    private store: Store<{ account: AccountState }>
  ) {}

  /** Эффект для получения данных аккаунта */
  getAccountData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountActions.getAccountData),
      switchMap(() =>
        this.apiService.GET<Account>('account').pipe(
          map((account) => AccountActions.getAccountDataSuccess({ account })),
          catchError((error) => of(AccountActions.getAccountDataFailure({ error })))
        )
      )
    )
  );
}
